<div *ngIf="loader; else blueprintTemplate" class="loader-container">
  <mat-spinner diameter="40"></mat-spinner>
</div>
<ng-template #blueprintTemplate>
<div class="flex flex-col">
  <!-- commenting for future use -->
  <!-- <div *ngIf="showTopBanner && dataLoaded && devInstance.length === 0 && !blueprint.demo
  && serviceVersionsInfo?.currentVersion?.applyConfigurationInstructionId" class="flex justify-center items-center top-banner max-width-lg"> -->
  <div *ngIf="showTopBanner && dataLoaded && devInstance?.length === 0 && !blueprint.demo && permissionsMap[Permission.DEPLOY_CONFIG_INSTANCE]"
    class="flex justify-center items-center top-banner max-width-lg">
    <div class="flex flex-row justify-center items-center">
      <div class="basis-full"></div>
      <div class="mr-16 green-oval white-fg">
        <mat-icon svgIcon="done" class="icon-sm"></mat-icon>
      </div>
      <div class="mr-40 ws-nowrap">{{ 'BLUEPRINT_SUMMARY.CONTINUE_WITH_FIRST_INSTANCE' | transloco }}</div>
      <button *ngIf="updatedPermissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_NONPII]" class="rounded accent create-dev-instance-btn" (click)="openCreateConfigurationInstanceForm()">
        {{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TITLE' | transloco}}
      </button>
      <div class="flex justify-end justify-center basis-full cursor-pointer">
        <mat-icon svgIcon="close" class="white-fg icon-md-1 mr-96" (click)="showTopBanner = false"></mat-icon>
      </div>
    </div>
  </div>
  <div class="max-width-lg bg-gradient overlap-instance">
    <app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>
    <div class="flex flex-row justify-between">
      <div *ngIf="service" class="flex flex-row flex-auto">
        <div class="flex flex-col mr-32">
          <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-24"
            [routerLink]="['/', tenant]"></mat-icon>
            <!-- <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-24"
            [routerLink]="['/', tenant, RouterSegments.SERVICES, service.id]"></mat-icon> -->
        </div>
        <div *ngIf="isSandbox" class="flex-col w-100-percent">
          <div class="flex flex-col">
            <div class="flex flex-row justify-between items-baseline">
              <div class="mat-headline-3 fw-600 mb-16">{{ service?.name }}</div>
              <div class="flex flex-row justify-center items-center service-deployment-status">
                <ng-container
                  *ngIf="devInstance && DeployStatus.DEPLOYED === devInstance[0]?.status && trialStatus.includes('expired'); else isNotExpired">
                  <div class="icon-container traffic-light warn-solid-bg mb-10">
                    <mat-icon svgIcon="error_outline" class="flex justify-center items-center white-fg icon icon-sm">
                    </mat-icon>
                  </div>
                  <div class="mat-subtitle-2 fw-600 ml-10 mb-8 word-break-word">
                    {{'SANDBOX.EXPIRED' | transloco}}
                  </div>
                </ng-container>
                <ng-template #isNotExpired>
                    <div class="icon-container traffic-light mb-10" [ngClass]="STATUS_CLASS[demoInstance?.status]">
                      <mat-icon [svgIcon]="STATUS_ICON[demoInstance?.status]"
                          class="flex justify-center items-center white-fg icon icon-sm"></mat-icon>
                    </div>
                    <div class="mat-subtitle-2 fw-600 mb-8 ml-10 word-break-word">
                      {{(demoInstance?.status ? 'INSTANCE_STATUS.' + demoInstance?.status : '') | transloco}}
                    </div>
                  <!-- <ng-template #showActiveHeader>
                    <div *ngIf="demoInstance?.status" [ngClass]="STATUS_CLASS[demoInstance?.status]"
                      class="traffic-light icon-container mr-16 mb-16">
                      <mat-icon class="flex justify-center items-center white-fg icon icon-sm"
                        [svgIcon]="STATUS_ICON[demoInstance?.status]"></mat-icon>
                    </div>
                    <div class="mat-subtitle-2 word-break-word" *ngIf="demoInstance?.status;else defaultText">
                      {{'INSTANCE_STATUS.' +
                      demoInstance?.status | transloco}}</div>
                    <ng-template #defaultText>
                      <div class="mat-subtitle-2 word-break-word">{{'INSTANCE_STATUS.NA' | transloco}}</div>
                    </ng-template>
                  </ng-template> -->
                </ng-template>
              </div>
            </div>
          </div>
          <div *ngIf="isSandbox" class="flex-col mr-20">
            <div class="mat-small fw-600 fs-18 trialStatusColor"
              *ngIf="devInstance && devInstance?.status !== DeployStatus.DEPLOYING && devInstance?.status !== DeployStatus.FAILED
                  && devInstance[0]?.status !== DeployStatus.FAILED && devInstance[0]?.status !== DeployStatus.DEPLOYING">
              {{trialStatus}}</div>
            <div class="flex-row mt-12 mb-30">
              <a (click)="openContactForm()"
                class="fs-16 mr-10 cursor-pointer mat-caption">{{'TOOLBAR.CONTACT_SALES' | transloco}}</a>
            </div>
          </div>
        </div>
        <div *ngIf="!isSandbox" class="flex flex-col flex-auto justify-between">
          <div class="flex-col">
            <div class="flex flex-row justify-between">
              <div class="mat-headline-3 mb-0">{{ isSandbox ? service.name : blueprint?.name }}</div>

              <div *ngIf="dataLoaded" class="flex flex-row justify-center items-center service-deployment-status">
                <div class="flex justify-center items-center mr-16" [ngClass]="isLive ? 'green-oval' : 'orange-oval'">
                  <mat-icon *ngIf="isLive" svgIcon="done" class="icon-sm"></mat-icon>
                  <mat-icon *ngIf="!isLive" svgIcon="change_circle" class="icon-sm"></mat-icon>
                </div>
                <div class="mat-subtitle-2 fw-600 mb-0">{{'SERVICE_STATUS.' + (!isLive ? 'IN_PROGRESS' : (isSandbox ?
                  'ACTIVE' : 'LIVE')) | transloco }}</div>
                <div class="actions">
                  <button *ngIf="updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE]" class="flex justify-center items-center context-menu-icon"
                    [matMenuTriggerFor]="blueprintActionsMenu">
                    <mat-icon svgIcon="more_vert"></mat-icon>
                  </button>
                  <mat-menu #blueprintActionsMenu [xPosition]="'before'" class="context-menu-dropdown">
                    <div class="flex-col" matTooltipClass="above" matTooltipPosition="above"
                      [matTooltip]="allInstances?.length > 0 ? ('BLUEPRINT_SUMMARY.TERMINATE_INSTANCES_BEFORE_DELETE' | transloco) : null">
                      <button class="delete-button" (click)="deleteBlueprint()"
                      [disabled]="allInstances?.length > 0 || !updatedPermissionsMap[PermissionKeys.BLUEPRINT_DELETE]"
                      [ngClass]="(allInstances?.length > 0 || !updatedPermissionsMap[PermissionKeys.BLUEPRINT_DELETE]) ? 'disabled' : '' ">
                        <div class="flex items-center">
                          <mat-icon svgIcon="delete" class="icon"></mat-icon>
                          <div class="mat-body-1 m-0 fw-400">{{'BUTTONS.DELETE' | transloco}}</div>
                        </div>
                      </button>
                    </div>
                  </mat-menu>
                </div>
              </div>
            </div>
            <div *ngIf="!isSandbox" class="mb-24">{{service?.name}}</div>
          </div>
          <div class="flex justify-between">
            <div *ngIf="serviceVersionsInfo" class="flex flex-row gap-x-8 mb-20">
              <!-- <div *ngIf="blueprint?.region" class="flex flex-row justify-center items-center service-region">
                <mat-icon svgIcon="place" class="icon-sm mr-6"></mat-icon>
                {{blueprint?.region | uppercase}}
              </div> -->
              <!-- <div class="flex flex-row justify-center items-center service-region">
                <mat-icon svgIcon="place" class="icon-sm mr-6"></mat-icon>
                {{tenantDetails?.region | titlecase}}
                {{tenantDetails.temenosRegion | titlecase}}
              </div> -->
              <!-- <div class="flex flex-row justify-center items-center service-version">
                <mat-icon svgIcon="token" class="icon-sm mr-6"></mat-icon>
                {{('BLUEPRINT_SUMMARY.BUILD_NUMBER' | transloco) + ' ' +
                (isSandbox ? (serviceVersionsInfo?.devVersion?.version) :
                (serviceVersionsInfo?.currentVersion?.version ? serviceVersionsInfo?.currentVersion?.version : 'N/A'))}}
              </div> -->
              <div *ngIf="serviceVersionsInfo?.currentVersion?.releaseVersion || serviceVersionsInfo?.devVersion?.releaseVersion" class="flex flex-row justify-center items-center">
                <mat-icon svgIcon="token" class="icon-sm mr-6"></mat-icon>
                <span class="mr-10">{{('BLUEPRINT_SUMMARY.RELEASE' | transloco) + ' ' + (latestReleaseVersion ? latestReleaseVersion : isSandbox ? serviceVersionsInfo?.devVersion?.releaseVersion : this.sortedSolutionVersionId[0]?.releaseVersion) }}</span>
                <div *ngIf="isAMR" class="flex flex-row justify-center items-center vertical-dash pl-10">
                  {{('BLUEPRINT_SUMMARY.AMR' | transloco)}}
                </div>
              </div>
              <!-- <mat-icon svgIcon="open_in_new" class="icon-sm mt-1 mr--30 "></mat-icon>
              <a class="view-release-internal-link cursor-pointer pb-0"
                *ngIf="viewReleaseNotes; else releaseNotesDisabled" [href]="viewReleaseNotes"
                target="_blank">{{'BLUEPRINT_SUMMARY.VIEW_RELEASE_NOTES' | transloco}}</a>
              <ng-template #releaseNotesDisabled>
                <div class="view-release-internal-link disabled-link cursor-default">
                  {{'BLUEPRINT_SUMMARY.VIEW_RELEASE_NOTES' | transloco}}</div>
              </ng-template> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isSandbox !== null && isSandbox !== undefined && !isSandbox; else sandboxView">
    <app-auto-update-info *ngIf="dataLoaded &&
      (serviceVersionsInfo?.comingSoonVersion || serviceVersionsInfo?.updateVersion)"
      [serviceVersionsInfo]="serviceVersionsInfo" [service]="service" [blueprint]="blueprint"
      (changeTaskChange)="onChangeTaskChange($event)"></app-auto-update-info>

    <div class="max-width-lg pb-130">
      <div class="flex flex-row mt-36">
        <div class="left-panel overlap-instance">
          <div class="vertical-menu">
            <div class="flex flex-row menu-item" [ngClass]="isInstanceSection ?  'selected' : 'null'"
              (click)="gotoSection(blueprintType.INSTANCES)">
              <mat-icon svgIcon="language" class="icon-md-1 mr-12"></mat-icon>
              {{ 'BLUEPRINT_SUMMARY.SIDE_MENU.ENVIRONMENT' | transloco }}
            </div>
            <!-- <div class="menu-group">{{ 'BLUEPRINT_SUMMARY.SIDE_MENU.SERVICE_DEFINITION' | transloco }}</div> -->
            <!-- <div class="flex flex-row" class="menu-item disabled">
              <mat-icon svgIcon="settings" class="icon-md-1 mr-12"></mat-icon>
              <div class="basis-full">
                {{ 'BLUEPRINT_SUMMARY.SIDE_MENU.SETTINGS' | transloco }}
              </div>
              <mat-icon svgIcon="expand_more" class="icon-md-1 ml-12"></mat-icon>
            </div> -->
             @if(!isExternalClient) {
            <div class="flex flex-row menu-item" [ngClass]="isServiceDefinitionSection ?  'selected' : 'null'"
              (click)="gotoSection(blueprintType.SERVICE_DEFINITION)">
              <mat-icon svgIcon="pages" class="icon-md-1 mr-12"></mat-icon>
              {{ 'BLUEPRINT_SUMMARY.SIDE_MENU.SERVICE_DEFINITION' | transloco }}
            </div>
             }
            <!-- <div class="menu-group">{{ 'BLUEPRINT_SUMMARY.SIDE_MENU.LIVE' | transloco }}</div>
            <div class="flex flex-row menu-item disabled">
              <mat-icon svgIcon="show_chart" class="icon-md-1 mr-12"></mat-icon>
              {{ 'BLUEPRINT_SUMMARY.SIDE_MENU.LIVE_METRICS' | transloco }}
            </div>
            <div class="flex flex-row menu-item disabled">
              <mat-icon svgIcon="equalizer" class="icon-md-1 mr-12"></mat-icon>
              {{ 'BLUEPRINT_SUMMARY.SIDE_MENU.USAGE_AND_COST' | transloco }}
            </div>
            <div class="menu-group">{{ 'BLUEPRINT_SUMMARY.SIDE_MENU.EVENTS' | transloco }}</div>
            <div class="flex flex-row menu-item disabled">
              <mat-icon svgIcon="notifications" class="icon-md-1 mr-12"></mat-icon>
              {{ 'BLUEPRINT_SUMMARY.SIDE_MENU.ALERTS' | transloco }}
            </div>
            <div class="flex flex-row menu-item disabled">
              <mat-icon svgIcon="format_list_bulleted" class="icon-md-1 mr-12"></mat-icon>
              {{ 'BLUEPRINT_SUMMARY.SIDE_MENU.LOG' | transloco }}
            </div> -->
          </div>
        </div>
        <div class="right-panel flex-auto">
          <app-page-loader *ngIf="instanceLoading"></app-page-loader>
          <ng-container *ngIf="isInstanceSection && dataLoaded">
            <!-- <div class="mat-headline-5 fw-700 fs-28 mb-24">{{ 'BLUEPRINT_SUMMARY.INSTANCES' | transloco }}</div> -->
            <div class="flex flex-row justify-between mt-10">
              <div class="mat-headline-5 fw-700 fs-28 mb-24 pr-0">{{ 'BLUEPRINT_SUMMARY.ENVIRONMENT' | transloco }}</div>
              <button class="btn-link mat-headline-6 fw-700 flex justify-center items-center"
                (click)="refreshInstanceForm();">
                <mat-icon svgIcon="refresh" class="mr-12" [@rotate]="count"
                (@rotate.done)="loading && count=count+1"></mat-icon>
                {{'BLUEPRINT_SUMMARY.REFRESH_INSTANCE' | transloco}}

              </button>
            </div>
            <mat-divider class="neutral-blue-6"></mat-divider>
            <!-- Dev instance if service is configurable -->
            <!-- commenting for future use -->
            <!-- <ng-container *ngIf="serviceVersionsInfo?.currentVersion?.applyConfigurationInstructionId"> -->
            <ng-container>
              <div class="flex flex-row justify-between mt-16 mb-10">
                <div class="mat-headline-5 fw-700 pr-0">{{ 'BLUEPRINT_SUMMARY.DEVELOPMENT_INSTANCE' | transloco }}</div>
                <button *ngIf="devInstance.length > 0 && updatedPermissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_NONPII]" class="flex items-center btn-link mat-headline-6 fw-700"
                  (click)="openCreateConfigurationInstanceForm()">
                  <mat-icon svgIcon="add" class="mr-12"></mat-icon>
                  {{'BLUEPRINT_SUMMARY.ADD_DEV_INSTANCE' | transloco}}
                </button>
              </div>
              <div *ngIf="devInstance.length === 0 else devInstanceCard;"
                class="flex flex-col justify-center items-center mt-40">
                <div *ngIf="updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]" class="neutral-blue-2-fg mb-40">{{ 'BLUEPRINT_SUMMARY.NO_INSTANCES_CREATED' | transloco }}</div>
                <button *ngIf="updatedPermissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_NONPII]" class="rounded accent create-dev-instance-btn"
                  (click)="openCreateConfigurationInstanceForm()">
                  {{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.TITLE' | transloco}}
                </button>
              </div>
              <ng-template #devInstanceCard>
                <div *ngIf="updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]">
                  <ng-container *ngFor="let instance of devInstance; let i = index;">
                    <ng-container [ngTemplateOutlet]="instanceCard" [ngTemplateOutletContext]="{instance}">
                    </ng-container>
                  </ng-container>
                </div>
              </ng-template>
            </ng-container>
            <div *ngIf="(devInstance?.length > 0 || allInstances?.length === 0) && !updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]" class="flex justify-center items-center">
              <div class="neutral-blue-2-fg mb-40 mt-20">{{ 'BLUEPRINT_SUMMARY.NO_INSTANCE_FOUND' | transloco }}</div>
            </div>
            <!-- commenting for future use -->
            <!-- <div *ngIf="((devInstance[0]?.status | isIn: INSTANCE_DEPLOYED_STATES) || !serviceVersionsInfo?.currentVersion?.applyConfigurationInstructionId) -->
            @if(!isExternalClient && devInstance?.length && !blueprint.pathToLiveConfiguration?.length) {
            <div class="flex justify-center">
              <button *ngIf="updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE]" class="rounded accent define-workflow-btn mt-40" (click)="defineWorkflow()">
                {{'INSTANCE_SUMMARY.DEFINE_WORKFLOW' | transloco}}
              </button>
            </div>
            }
            <ng-container *ngIf="blueprint.pathToLiveConfiguration?.length || testDataZoneInstances?.length || piiDataZoneInstances?.length || liveDataZone?.length || !this.devInstances">
              @if(!isExternalClient) {
              <div class="flex fled-row justify-between mt-24 mb-24">
                <div class="mat-headline-5 fw-700 mb-0">{{'BLUEPRINT_SUMMARY.PATH_TO_LIVE_WORKFLOW' | transloco}}</div>
                <button *ngIf="updatedPermissionsMap[PermissionKeys.BLUEPRINT_UPDATE] && blueprint.pathToLiveConfiguration?.length" class="flex items-center btn-link mat-headline-6 fw-700" (click)="defineWorkflow()">
                  <mat-icon svgIcon="edit" class="mr-12"></mat-icon>
                  {{'BLUEPRINT_SUMMARY.EDIT_WORKFLOW' | transloco}}
                </button>
              </div>
              }
              <!-- Test data zone instances -->
              <div *ngIf="testDataZoneInstances?.length" class="instances-group mb-24" [ngClass]="isExternalClient ? 'mt-24': ''">
                <div class="test-data-zone-title overline-font">{{'INSTANCE_SUMMARY.TEST_DATA_ZONE' | transloco |
                  uppercase}}</div>
                <div class="test-data-zone-content" *ngIf="updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]">
                  <ng-container *ngFor="let instance of testDataZoneInstances; let i = index;">
                    <ng-container [ngTemplateOutlet]="instanceCard" [ngTemplateOutletContext]="{instance}">
                    </ng-container>
                    <mat-divider *ngIf="i < testDataZoneInstances.length - 1" class="neutral-blue-6 ml-24 mr-24">
                    </mat-divider>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="testDataZoneInstances?.length > 0 && !updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII]" class="flex justify-center items-center">
                <div class="neutral-blue-2-fg mb-40 mt-20">{{ 'BLUEPRINT_SUMMARY.NO_INSTANCE_FOUND' | transloco }}</div>
              </div>
              <!-- PII data zone instances -->
              <div *ngIf="piiDataZoneInstances?.length" class="instances-group mb-24">
                <div class="pii-data-zone-title overline-font">{{'INSTANCE_SUMMARY.PII_DATA_ZONE' | transloco |
                  uppercase}}</div>
                <div class="pii-data-zone-content">
                  <ng-container *ngFor="let instance of piiDataZoneInstances; let i = index;">
                    <ng-container *ngIf="(instance?.dataZone === DataZone.SECURE && updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]) || 
                    (instance?.dataZone === DataZone.LIVE && updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE])"  [ngTemplateOutlet]="instanceCard" [ngTemplateOutletContext]="{instance}">
                    </ng-container>
                    <mat-divider *ngIf="i < piiDataZoneInstances.length - 1" class="neutral-blue-6 ml-24 mr-24">
                    </mat-divider>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="piiDataZoneInstances?.length > 0 && !updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE] && !updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII]" class="flex justify-center items-center">
                <div class="neutral-blue-2-fg mb-40 mt-20">{{ 'BLUEPRINT_SUMMARY.NO_INSTANCE_FOUND' | transloco }}</div>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="isInstanceSection && !dataLoaded">
            <div class="flex flex-row justify-between mt-10 mb-10">
              <div class="mat-headline-5 fw-700 fs-28 mb-24 pr-0">{{ 'BLUEPRINT_SUMMARY.ENVIRONMENT' | transloco }}</div>
            </div>
            <mat-divider class="neutral-blue-6 pb-30"></mat-divider>
            <ng-container *ngFor="let item of [1,2,3]">
              <div class="instance-card instances-group flex flex-col mb-8 p-28">
                  <ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
                  <div class="flex flex-row pt-24">
                    <ng-container *ngFor="let item of [1,2,3,4]">
                      <ngx-skeleton-loader class="loader-line mr-50" count="1" appearance="line"></ngx-skeleton-loader>
                    </ng-container>
                  </div>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="isServiceDefinitionSection">
            <div class="flex flex-row justify-between mt-10">
              <div class="mat-headline-5 fw-700 fs-28 mb-24">{{ 'BLUEPRINT_SUMMARY.SERVICE_DEFINITION' | transloco }}
              </div>
              <button class="flex flex-row basic-button mat-subtitle-2 fw-700 h-auto mb-0 fs-20"
                (click)="createNewBtnEnable ? extendedService(blueprintLatestVersion?.capabilities?.length) : null"
                *ngIf="blueprintLatestVersion?.capabilities?.length && ( updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE])"
                [ngClass]="[(blueprintLatestVersion?.capabilities?.length === 0) || (!createNewBtnEnable) ? 'disabled-btn cursor-default' : 'cursor-pointer']"
                [disabled]="!updatedPermissionsMap[PermissionKeys.BLUEPRINT_CREATE]"
                [matTooltip]="createNewBtnEnable ? '' : 'BLUEPRINT_SUMMARY.CREATE_NEW_DISABLE' | transloco"
                matTooltipPosition="above"
                matTooltipClass="mat-tooltip tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16">
                <mat-icon svgIcon="add" class="mr-12 icon-md-1"></mat-icon>
                {{ 'BLUEPRINT_SUMMARY.CREATE_NEW' | transloco }}
              </button>
            </div>
            <mat-divider class="neutral-blue-6 mb-24"></mat-divider>
            <mat-accordion>
              <mat-expansion-panel [hideToggle]="true" *ngFor="let version of blueprintsVersionList; let i = index;"
                class="mb-8">
                <mat-expansion-panel-header class="h-72" #versionPanel
                  (click)="!blueprintLatestVersion?.capabilities?.length ? versionPanel._toggle(): 'null' ">
                  <mat-panel-title class="mat-subtitle-2 fw-500 m-0">
                    <mat-icon *ngIf="blueprintLatestVersion?.capabilities?.length"
                      [svgIcon]="versionPanel._isExpanded() ? 'expand_more' : 'chevron_right'"
                      class="icon-md mr-32"></mat-icon>
                    {{'BLUEPRINT_SUMMARY.VERSION' | transloco }} {{ version?.version }}
                    <mat-chip-list class="ml-8"
                      *ngIf="isNewServiceDefinitionVersion && blueprintsVersionList?.length === (i+1)">
                      <mat-chip class="new-temenos-accent-1-bg white-fg">{{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.NEW' |
                        transloco}}</mat-chip>
                    </mat-chip-list>
                  </mat-panel-title>
                  <mat-panel-title class="mat-subtitle-2 m-0">
                    <div class="flex flex-row justify-between">
                      <span
                        *ngIf="(liveDataZone?.environment === 'LIVE' && liveDataZone?.status === 'deployed' && liveDataZone?.blueprintVersionId === version?.id); else showDraftVersion"
                        class="flex flex-row">
                        <div class="flex items-center green-oval white-fg mr-16">
                          <mat-icon svgIcon="done" class="icon-sm"></mat-icon>
                        </div>
                        <div class="fw-600">{{'BLUEPRINT_SUMMARY.LIVE' | transloco }}</div>
                      </span>
                      <ng-template #showDraftVersion>
                        <div class="flex flex-row">
                          <div class="mr-16"
                            [ngClass]="!serviceVersionStatus(version?.id) ? 'blue-oval' : 'orange-oval'">
                            <mat-icon [svgIcon]="!serviceVersionStatus(version?.id) ? 'note_alt' : 'change_circle'"
                              class="icon-sm"></mat-icon>
                          </div>
                          <div class="fw-600">{{serviceVersionStatus(version?.id) ? ('BLUEPRINT_SUMMARY.IN_PROGRESS' |
                            transloco) : ('BLUEPRINT_SUMMARY.DRAFT' | transloco)}}</div>
                        </div>
                      </ng-template>
                    </div>
                  </mat-panel-title>
                  <mat-panel-title class="mat-body-2">
                    <span
                      *ngIf="(liveDataZone?.environment === 'LIVE' && liveDataZone?.status === 'deployed' &&  liveDataZone?.blueprintVersionId === version?.id); else showCreated">
                      {{ 'BLUEPRINT_SUMMARY.DEPLOYED' | transloco }} {{ deployedDate | date : 'd MMM y hh:mm':'+0000' }}
                      {{ 'BLUEPRINT_SUMMARY.UTC' | transloco }}
                    </span>
                    <ng-template #showCreated>
                      {{ 'BLUEPRINT_SUMMARY.CREATED' | transloco }} {{ version?.dateCreated | date : 'd MMM yyyy
                      hh:mm':'+0000' }} {{'BLUEPRINT_SUMMARY.UTC' | transloco }}
                    </ng-template>
                  </mat-panel-title>
                  <!-- <mat-panel-title class="flex justify-end mat-body-2 fw-500 m-0" (click)="!versionPanel._toggle()">
                    <button class="flex justify-start basic-button mat-button button-underline cursor-pointer p-0 h-30 hidden"
                      (click)="showViewDetails(version)">
                      {{ 'BLUEPRINT_SUMMARY.VIEW_DETAILS' | transloco }}
                    </button>
                    <div *ngIf="updatedPermissionsMap[PermissionKeys.BLUEPRINT_DELETE]" class="actions">
                      <button *ngIf="permissionsMap[Permission.SERVICE_DEF_MENU]" class="flex items-center context-menu-icon pr-0"
                        (click)="stopPropagation($event)"
                        [matMenuTriggerFor]="blueprintVersionMenu">
                        <mat-icon svgIcon="more_vert" class="flex justify-end"></mat-icon>
                      </button>
                      <mat-menu #blueprintVersionMenu [xPosition]="'before'" class="context-menu-dropdown">
                        <button class="flex justify-start action-button h-40"
                          [disabled]="((!isInstance || liveDataZone?.environment === 'LIVE' && liveDataZone?.status === DeployStatus.DEPLOYED && liveDataZone?.blueprintVersionId === version?.id) || (serviceVersionStatus(version?.id)))"
                          (click)="((!isInstance || liveDataZone?.environment === 'LIVE' && liveDataZone?.status === DeployStatus.DEPLOYED && liveDataZone?.blueprintVersionId === version?.id) || (serviceVersionStatus(version?.id))) ? null : deleteServiceDefinition(version?.id)">
                          <div class="fw-400 mt-6">
                            <mat-icon svgIcon="delete" class="icon mt--2"></mat-icon>
                            {{'BUTTONS.DELETE' | transloco}}
                          </div>
                        </button>
                      </mat-menu>
                    </div>
                  </mat-panel-title> -->
                </mat-expansion-panel-header>
                <div *ngIf="version?.capabilities?.length" class="ml-20 mr-20">
                  <div class="mat-headline-5 fw-700 mb-24 mt-28 pl-10">
                    {{'INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES' | transloco}}
                    ({{version?.capabilities?.length}})
                  </div>
                  <div class="flex flex-wrap ml--12 mr--12 pl-20 card-gap">
                    <ng-container *ngFor="let capability of version.capabilities">
                      <div class="w-1/3 pl-12 pr-12 mb-24 btn-bgcolor">
                        <app-view-capability-card class="w-100-percent" [capability]="capability">
                        </app-view-capability-card>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</div>
</ng-template>

<ng-template #instanceCard let-instance="instance"> 
  <div class="flex flex-col" class="instance-card" [ngClass]="{'instances-group mb-8': instance.deploymentClass === deploymentClass.D, 'cursor-pointer': instance?.status !== DeployStatus.NOT_DEPLOYED,
    'disable-click': (instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.STOPPING)}"
    (click)="instance?.status !== DeployStatus.NOT_DEPLOYED ? instanceClick(instance) : none">
    <div class="flex flex-row content">
      <span class="hidden">
        <mat-icon [svgIcon]="instance.expanded ? 'expand_more' : 'chevron_right'"
          class="icon-md-1 mr-16 cursor-pointer user-select-none" (click)="instance.expanded = !instance.expanded">
        </mat-icon>
      </span>
      <div class="flex flex-col basis-full">
        <div class="flex flex-row basis-full instance-details items-baseline">
          <div class="flex basis-full mat-headline-6 mb-8">
            <span [ngClass]="{'clickable': (instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.STOPPING)}"
            (click)="(instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.STOPPING) ? instanceClick(instance) : null">
            {{ instance.name }}</span>
          </div>
          <!-- <div class="flex basis-full">
            <div class="mat-headline-6 mb-8">{{ instance.name }}</div>
            <legend *ngIf="instance.dataZone === DataZone.LIVE" class="ml-12"> 
              <span [ngClass]="[instance.deploymentClass === deploymentClass.A ? 'color-green' : 'color-purple']">Class {{instance.deploymentClass}}</span>
            </legend>
          </div>           -->
          <div class="flex justify-end instance-inline-actions" [ngClass]="{'disable': (instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.STOPPING)}">
            <button
            *ngIf="instance.status === DeployStatus.DEPLOYED || instance.status === DeployStatus.TESTED || instance.status === DeployStatus.CONFIGURED || instance.status === DeployStatus.CONFIGURATION_FAILED || instance.status === DeployStatus.UPDATING || instance.status === DeployStatus.UPDATED
              || instance.status === DeployStatus.UPDATE_FAILED || instance.status === DeployStatus.TEST_FAILED"
              class="viewEndpoint menu-button rounded white mr-16"
              (click)="openViewEndpointsComponent(instance, $event)" [disabled]="!endpointView">
              <div class="flex flex-row" matTooltipClass="above" matTooltipPosition="above"
                [matTooltip]="!endpointView ? ('BLUEPRINT_SUMMARY.ERROR.ENDPOINTS_NOT_AVAILABLE' | transloco) : null">
                <mat-icon svgIcon="desktop_windows" class="icon-sm"></mat-icon>
                <span [ngClass]="{'endpoint-disabled': !endpointView}"
                  class="only-show-on-hover ml-12">{{'INSTANCE_SUMMARY.MENU.VIEW_ENDPOINTS' | transloco}}</span>
              </div>
            </button>
            <button *ngIf="instance.status === DeployStatus.FAILED
            && ((updatedPermissionsMap[PermissionKeys.INSTANCE_REDEPLOY_DATAZONE_PII] && instance?.dataZone === DataZone.SECURE)
            || (updatedPermissionsMap[PermissionKeys.INSTANCE_REDEPLOY_DATAZONE_LIVE] && instance?.dataZone === DataZone.LIVE)
            || (updatedPermissionsMap[PermissionKeys.INSTANCE_REDEPLOY_DATAZONE_NONPII] && instance?.dataZone === DataZone.DEVELOPMENT))" class="rounded ml-12 accent instance-summary-btn"
              (click)="onReDeploy(instance, $event)">
              {{'INSTANCE_SUMMARY.TABLE.RE_DEPLOY' | transloco}}
            </button>
            <button *ngIf="instance.deploymentClass === devDeploymentClass && instance.status !== DeployStatus.FAILED" class="rounded white"
              [ngClass]="{'gotoWorkBench-disabled': !gotoWorkBenchURL(instance)}"
              [disabled]="instance.status | isNotIn: INSTANCE_DEPLOYED_STATES || !permissionsMap[Permission.CONFIGURE_SERVICE] || !workbenchUrl"
              (click)="navigateToWorkbench($event)">
              <div class="flex flex-row">
                <mat-icon svgIcon="open_in_new" class="icon-sm mr-12"></mat-icon>
                <span>{{'INSTANCE_SUMMARY.TABLE.GO_TO_WORKBENCH' | transloco}}</span>
              </div>
            </button>
            @if(!isExternalClient) {
            <ng-container
              *ngIf="!instance.id || (instance.status === DeployStatus.DEPLOYING && instance.deploymentClass !== devDeploymentClass)"
              [ngTemplateOutlet]="deployPTLButtons"
              [ngTemplateOutletContext]="{ instance: instance,
                workflowApproval: groupedWorkflowApprovals.get(blueprint.id + OperationType.CREATE_INSTANCE + instance.environment) }">
            </ng-container>
            <ng-container *ngIf="serviceVersionsInfo?.currentVersion?.applyConfigurationInstructionId && instance.id
              && instance.deploymentClass !== devDeploymentClass && instance.status | isIn: INSTANCE_DEPLOYED_STATES"
              [ngTemplateOutlet]="updatePTLButtons" [ngTemplateOutletContext]="{ instance: instance,
                workflowApproval: groupedWorkflowApprovals.get(instance.id + OperationType.UPDATE_INSTANCE) }">
            </ng-container>
            <button class="flex items-center instance-actions context-menu-icon pl-6 pr-6" (click)="updateConfiguration(instance, $event)"
              [matMenuTriggerFor]="instanceSubmenu">
              <mat-icon svgIcon="more_vert"></mat-icon>
            </button>
            }
            <mat-menu #instanceSubmenu [xPosition]="'before'" class="context-menu-dropdown">
              <div class="flex flex-col" *ngIf="(instance?.status !== DeployStatus.STARTING && instance?.status !== DeployStatus.START_FAILED && instance?.status !== DeployStatus.STOPPING)">
                <div *ngIf="blueprintLatestVersion?.capabilities?.length !== 0" >
                  <button
                  *ngIf="(instance?.dataZone === DataZone.DEVELOPMENT && updatedPermissionsMap[PermissionKeys.INSTANCE_EXTEND_DATAZONE_NONPII]) ||
                  (instance?.dataZone === DataZone.SECURE && updatedPermissionsMap[PermissionKeys.INSTANCE_EXTEND_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && updatedPermissionsMap[PermissionKeys.INSTANCE_EXTEND_DATAZONE_LIVE])"
                  [disabled]="blueprintsVersionList?.length <=1 || (instance.status | isNotIn : INSTANCE_AVAILABLE_STATES)"
                  class="menu-button" (click)="openServiceDefinitionComponent(instance)">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="pages"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{'INSTANCE_SUMMARY.UPDATE_MENU.UPDATE_SERVICE_DEFINITION' |
                      transloco}}</div>
                  </div>
                </button>
                </div>
                <button *ngIf="instance?.dataZone !== DataZone.DEVELOPMENT && releaseManager"
                 class="menu-button" [disabled]="(updateReleasePackage === 0 || (instance.status | isNotIn : INSTANCE_AVAILABLE_STATES))" (click)="liveInstance(instance)">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="newRelease" class="mt-4"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{('INSTANCE_SUMMARY.UPDATE_MENU.UPDATE_RELEASE_PACKAGE' | transloco)}}</div>
                  </div>
                </button>
                <button *ngIf="(instance?.dataZone === DataZone.DEVELOPMENT) && (instance?.latestConfigurationState?.status !== ConfigurationApplicationStatus.VERIFIED) && ((instance?.dataZone === DataZone.DEVELOPMENT && updatedPermissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII]) ||
                (instance?.dataZone === DataZone.SECURE && updatedPermissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && updatedPermissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE]))"
                 class="menu-button" [disabled]="(updateReleasePackage === 0) || (instance?.latestConfigurationState?.instanceId === instance.id && !instance?.latestConfigurationState?.status)
                || instance.status !== DeployStatus.DEPLOYED && instance.status !== DeployStatus.UPDATED && instance.status !== DeployStatus.CONFIGURED && instance.status !== DeployStatus.TESTED && instance.status !== DeployStatus.CONFIGURATION_FAILED && instance.status !== DeployStatus.TEST_FAILED
                || ((instance?.latestConfigurationState?.instanceId === instance.id && instance.environment === PathToLiveEnvironment.LIVE) && (instance?.latestConfigurationState?.status !== ConfigurationApplicationStatus.SUCCESS))" (click)="updateInstance(instance, workflowApproval, instance?.latestConfigurationState?.status)">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="newRelease" class="mt-4"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{instance.environment === PathToLiveEnvironment.LIVE ? (instance?.latestConfigurationState?.status !== ConfigurationApplicationStatus.VERIFIED ? ('INSTANCE_SUMMARY.UPDATE_MENU.VERIFY_UPDATE_RELEASE_PACKAGE' | transloco) : ('INSTANCE_SUMMARY.UPDATE_MENU.UPDATE_RELEASE_PACKAGE' | transloco)) : ('INSTANCE_SUMMARY.UPDATE_MENU.UPDATE_RELEASE_PACKAGE' | transloco)}}</div>
                  </div>
                </button>
                <button *ngIf="(instance.environment !== PathToLiveEnvironment.PREPROD) && (instance?.latestConfigurationState?.status === ConfigurationApplicationStatus.VERIFIED) && ((instance?.dataZone === DataZone.DEVELOPMENT && updatedPermissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_NONPII]) ||
                (instance?.dataZone === DataZone.SECURE && updatedPermissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && updatedPermissionsMap[PermissionKeys.INSTANCE_CONFIG_DATAZONE_LIVE]))" class="menu-button" [disabled]="instance.status !== DeployStatus.TESTED && instance.status !== DeployStatus.UPDATED && instance.status !== DeployStatus.UPDATE_FAILED && instance.status !== DeployStatus.DEPLOYED && instance.status !== DeployStatus.CONFIGURED && instance.status !== DeployStatus.CONFIGURATION_FAILED && instance.status !== DeployStatus.TEST_FAILED
                || ((instance?.latestConfigurationState?.instanceId === instance.id && instance.environment === PathToLiveEnvironment.LIVE) && (instance?.latestConfigurationState?.status !== ConfigurationApplicationStatus.VERIFIED))" (click)="updateInstance(instance, workflowApproval, instance?.latestConfigurationState?.status)">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="newRelease" class="mt-4"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{instance.environment === PathToLiveEnvironment.LIVE ? (instance?.latestConfigurationState?.status !== ConfigurationApplicationStatus.VERIFIED ? ('INSTANCE_SUMMARY.UPDATE_MENU.VERIFY_UPDATE_RELEASE_PACKAGE' | transloco) : ('INSTANCE_SUMMARY.UPDATE_MENU.UPDATE_RELEASE_PACKAGE' | transloco)) : ('INSTANCE_SUMMARY.UPDATE_MENU.UPDATE_RELEASE_PACKAGE' | transloco)}}</div>
                  </div>
                </button>

                <!-- <button *ngIf="(instance.deploymentClass === deploymentClass.D && permissionsMap[Permission.TERMINATE_CONFIG_INSTANCE]) ||
                (instance.deploymentClass !== deploymentClass.D && permissionsMap[Permission.TERMINATE_PTL_INSTANCE])" [disabled]="instance?.status !== DeployStatus.DEPLOYED" class="menu-button" (click)="applyLocalConfig(instance)">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="settings_applications"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{'INSTANCE_SUMMARY.MENU.APPLY_LOCAL_CONFIG' | transloco}}</div>
                  </div>
                </button> -->

                <!-- <button class="menu-button" [disabled]="instance.status !== DeployStatus.DEPLOYED && instance.status !== DeployStatus.CONFIGURED || (instance === devInstance && !permissionsMap[Permission.TERMINATE_CONFIG_INSTANCE])
                || (instance !== devInstance && !permissionsMap[Permission.TERMINATE_PTL_INSTANCE])" (click)="updateInstance(instance, workflowApproval, instance?.latestConfigurationState?.status)">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="newRelease"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{instance.environment === PathToLiveEnvironment.LIVE ?
                      (instance?.latestConfigurationState?.status !== ConfigurationApplicationStatus.VERIFIED ?
                      ('INSTANCE_SUMMARY.UPDATE_MENU.VERIFY_UPDATE_RELEASE_PACKAGE' | transloco) :
                      ('INSTANCE_SUMMARY.UPDATE_MENU.UPDATE_RELEASE_PACKAGE' | transloco)) :
                      ('INSTANCE_SUMMARY.UPDATE_MENU.UPDATE_RELEASE_PACKAGE' | transloco)}}</div>
                  </div>
                </button> -->
                <span *ngIf="!(instance.environment === PathToLiveEnvironment.LIVE && blueprintLatestVersion?.capabilities?.length === 0 && !permissionsMap[Permission.APPLY_RELEASE_PACKAGE_HOTFIX]) && ((instance.deploymentClass === deploymentClass.D && (permissionsMap[Permission.TERMINATE_CONFIG_INSTANCE] || permissionsMap[Permission.APPLY_RELEASE_PACKAGE])) ||
                (instance.deploymentClass !== deploymentClass.D && permissionsMap[Permission.APPLY_RELEASE_PACKAGE]))" class="divider-sm submenu"></span>
                <button *ngIf="(instance.configurationStates?.length > 0
                  || (instance.latestConfigurationState?.status | isIn: CONFIGURATION_FINAL_STATES))
                  " [disabled]="(instance.status | isNotIn : INSTANCE_AVAILABLE_STATES)"
                  class="menu-button" (click)="viewUpdateResults(instance)">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="description" class="icon"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{'INSTANCE_SUMMARY.MENU.VIEW_RESULTS' | transloco}}</div>
                  </div>
                </button>
                <button *ngIf="instance?.status !== DeployStatus.NOT_DEPLOYED"
                  class="menu-button" (click)="instanceClick(instance)">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="visibility" class="icon pt-2"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{'INSTANCE_SUMMARY.MENU.VIEW_DETAILS' | transloco}}</div>
                  </div>
                </button>

                <button
                  *ngIf="(instance.status === DeployStatus.DEPLOYED && blueprintLatestVersion?.capabilities?.length !== 0) &&
                  ((instance.deploymentClass === deploymentClass.D && permissionsMap[Permission.TERMINATE_CONFIG_INSTANCE]) ||
                  (instance.deploymentClass !== deploymentClass.D && permissionsMap[Permission.TERMINATE_PTL_INSTANCE]))"
                  (click)="secret(instance)" class="menu-button">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="lock" class="icon mr-6 mt-2"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{'INSTANCE_SUMMARY.MENU.SECRETS' | transloco}}</div>
                  </div>
                </button>
                <button (click)="onSupportClick()" class="menu-button">
                  <div class="flex flex-row justify-start items-center">
                    <!-- <div class="flex items-center"> -->
                    <mat-icon svgIcon="info" class="icon mr-6 mt-2"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{'INSTANCE_SUMMARY.MENU.REPORT_ISSUE' | transloco}}</div>
                  </div>
                </button>
                <button (click)="terminate(instance)" class="terminate-button" *ngIf="(instance?.dataZone === DataZone.DEVELOPMENT && updatedPermissionsMap[PermissionKeys.INSTANCE_DELETE_DATAZONE_NONPII]) ||
                (instance?.dataZone === DataZone.SECURE && updatedPermissionsMap[PermissionKeys.INSTANCE_DELETE_DATAZONE_PII]) || (instance?.dataZone === DataZone.LIVE && updatedPermissionsMap[PermissionKeys.INSTANCE_DELETE_DATAZONE_LIVE])"
                  [disabled]="instance.status | isNotIn : INSTANCE_AVAILABLE_STATES
                          || (instance.configurationStates?.length > 0 && instance.latestConfigurationState?.status !== ConfigurationApplicationStatus.SUCCESS && instance.latestConfigurationState?.status !== ConfigurationApplicationStatus.VERIFIED)">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="delete" class="icon"></mat-icon>
                    <div class="mat-body-1 m-0 fw-400">{{'INSTANCE_SUMMARY.MENU.TERMINATE' | transloco}}</div>
                  </div>
                </button>
              </div>
            </mat-menu>
          </div>
        </div>

        <div *ngIf="!instance.expanded; else instanceExpandedDetails" [ngClass]="{'disable': (instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.STOPPING)}"
          class="flex flex-row justify-start items-center instance-summary neutral-blue-2-fg mt-10">
          <div class="flex flex-row justify-start items-center status mr-32 w-[10%]">
            {{ 'BLUEPRINT_SUMMARY.SUMMARY.STATUS' | transloco }}
            <div class="status-light ml-12 mr-8 white-fg"
              [ngClass]="[(instance.status | isIn: INSTANCE_DEPLOYED_STATES) ? 'green-oval-sm' : (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.FAILED) ? 'red-oval-sm' : 'neutral-blue-3-oval-sm']">
            </div>
            <div class="status-value ws-nowrap">
              {{ (((instance.status | isIn: INSTANCE_DEPLOYED_STATES) || instance.status === DeployStatus.FAILED) ? ('BLUEPRINT_SUMMARY.ACTIVE' | transloco) : instance?.status === DeployStatus.STOPPED ? (instance?.status | titlecase) :
              ('BLUEPRINT_SUMMARY.NA' | transloco)) }}
            </div>
          </div>
          <div class="flex flex-row mr-32 w-[15%]">
            {{ 'BLUEPRINT_SUMMARY.SUMMARY.SERVICE_DEFINITION' | transloco }}
            <div class="service-definition-value fw-700 ml-20">{{isBlueprintsVersionlAvaliable(blueprintsVersionList,
              instance.blueprintVersionId)?.length? getVersion[0]?.version: '-'}}</div>
          </div>

          <div class="flex flex-row environment mr-32 w-[15%]">
            {{ 'BLUEPRINT_SUMMARY.SUMMARY.ENVIRONMENT' | transloco }}
            <div class="environment-value ml-12">{{ instance.deploymentClass === devDeploymentClass ? 'DEV' :
              instance.environment || instance?.targetEnvironment}}</div>
          </div>

          <div class="flex flex-row release-package ws-nowrap mr-32 w-[15%]">
            {{ 'BLUEPRINT_SUMMARY.SUMMARY.RELEASE_PACKAGE' | transloco }}
            <div *ngIf="instance.environment === PathToLiveEnvironment.LIVE" class="release-package-value ml-12">
              {{ liveReleaseData ? liveReleaseData : '-' }}
            </div>
            <div *ngIf="instance.environment !== PathToLiveEnvironment.LIVE" class="release-package-value ml-12">
              {{ instance.activeConfiguration ? instance.activeConfiguration.manifest.version : '-' }}
            </div>
          </div>
          <div class="flex flex-row justify-center items-center service-version">
             {{('BLUEPRINT_SUMMARY.RELEASE' | transloco) + ': ' +
             (instance.status === DeployStatus.NOT_DEPLOYED  ? '-' : getBuildVersion(instance?.solutionVersionId)) }}
          </div>
        </div>

        <ng-template #instanceExpandedDetails>
          <div class="instance-summary expanded">
            <div class="flex flex-row mb-16">
              <div class="flex justify-between w-50-percent environment">
                {{ 'BLUEPRINT_SUMMARY.SUMMARY.ENVIRONMENT' | transloco }}
                <div class="w-2/3 environment-value fw-700">{{ instance.deploymentClass === devDeploymentClass ? 'DEV' :
                  instance.environment }}</div>
              </div>
              <div class="flex justify-between w-50-percent release-package">
                {{ 'BLUEPRINT_SUMMARY.SUMMARY.RELEASE_PACKAGE' | transloco }}
                <div *ngIf="instance.environment === PathToLiveEnvironment.LIVE"
                  class="w-2/3 release-package-value fw-700">{{ liveReleaseData ? liveReleaseData : '-' }}</div>
                <div *ngIf="instance.environment !== PathToLiveEnvironment.LIVE"
                  class="w-2/3 release-package-value fw-700">{{ instance.activeConfiguration ?
                  instance.activeConfiguration.manifest.version : '-' }}</div>
              </div>
            </div>
            <div class="flex flex-row">
              <div class="flex justify-between w-50-percent status">
                {{ 'BLUEPRINT_SUMMARY.SUMMARY.STATUS' | transloco }}
                <div class="flex flex-row justify-start items-center w-2/3">
                  <div *ngIf="instance.status | isIn: INSTANCE_DEPLOYED_STATES; else notActivated"
                    class="justify-items-center green-oval white-fg mr-16">
                    <mat-icon svgIcon="done" class="icon-sm"></mat-icon>
                  </div>
                  <ng-template #notActivated>
                    <div class="status-light mr-8 neutral-blue-3-oval-sm"></div>
                  </ng-template>
                  <div class="status-value ws-nowrap fw-700">
                    {{ ((instance.status | isIn: INSTANCE_DEPLOYED_STATES) ? 'BLUEPRINT_SUMMARY.ACTIVE' :
                    'BLUEPRINT_SUMMARY.NA') | transloco }}
                  </div>
                </div>
              </div>
              <div class="flex flex-row w-50-percent">
                <div class="w-1/3">{{ 'BLUEPRINT_SUMMARY.SUMMARY.SERVICE_DEFINITION' | transloco }}</div>
                <div class="service-definition-value fw-700">{{isBlueprintsVersionlAvaliable(blueprintsVersionList,
                  instance.blueprintVersionId)?.length? getVersion[0]?.version: '-'}}</div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <div *ngIf="serviceDefinitionUpdate && instance.status === DeployStatus.DEPLOYING" class="flex flex-row justify-center items-center instance-info-line warn">
      <mat-spinner diameter="24" class="w-24 h-24 mr-8"></mat-spinner>
      {{ 'INSTANCE_SUMMARY.SERVICE_DEFINITION.UPDATING_SERVICE_DEFINITION' | transloco }}
    </div>

    <div *ngIf="!serviceDefinitionUpdate && instance.status === DeployStatus.DEPLOYING || instance.status === DeployStatus.TERMINATING
    || instance.status === DeployStatus.FAILOVER_APPLYING || instance.status === DeployStatus.FAILBACK_APPLYING || instance.status === DeployStatus.PRE_FAILBACK_APPLYING || instance?.status === DeployStatus.STARTING || instance?.status === DeployStatus.STOPPING || instance?.status === DeployStatus.OPERATION_INPROGRESS"
      class="flex flex-row justify-center items-center instance-info-line warn">
      <mat-spinner diameter="24" class="w-24 h-24 mr-8"></mat-spinner>
      {{ (instance.status === DeployStatus.OPERATION_INPROGRESS ? ('INSTANCE_SUMMARY.SERVICE_DEFINITION.OPERATION_INPROGRESS' | transloco) : (instance.status | titlecase)) }}
    </div>

    <div *ngIf="!serviceDefinitionUpdate && instance.status === DeployStatus.FAILED || instance.status === DeployStatus.FAILOVER_FAILED || instance.status === DeployStatus.FAILBACK_FAILED || instance.status === DeployStatus.PRE_FAILBACK_FAILED || instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.STOP_FAILED || instance?.status === DeployStatus.STOPPED"
      class="flex flex-row justify-center items-center instance-info-line warn">
      <div class="mr-6 icon-container">
        <mat-icon svgIcon="error_outline" class="icon icon-md warn-solid-fg"></mat-icon>
      </div>
      <span class="termination-failed">
        {{ (instance?.status === DeployStatus.START_FAILED || instance?.status === DeployStatus.STOP_FAILED || instance?.status === DeployStatus.STOPPED) ? (instance?.status | titlecase) : ('BLUEPRINT_SUMMARY.DEPLOYMENT_FAILED' | transloco) }}
      </span>
    </div>

    <div *ngIf="!serviceDefinitionUpdate && instance.status === DeployStatus.TERMINATION_FAILED"
      class="flex flex-row justify-center items-center instance-info-line warn">
      <div class="mr-16 icon-container">
        <mat-icon svgIcon="error_outline" class="icon icon-md warn-solid-fg"></mat-icon>
      </div>
      <span class="termination-failed">
        {{'BLUEPRINT_SUMMARY.TERMINATION_FAILED' | transloco }}
      </span>
    </div>
      <div *ngIf="!serviceDefinitionUpdate && instance.status === DeployStatus.CONFIGURATION_FAILED && (instance?.latestConfigurationState?.status !== ConfigurationApplicationStatus.CONFIGURE_FAILED && instance?.latestConfigurationState?.status !== ConfigurationApplicationStatus.TEST_FAILED)"
        class="flex flex-row justify-center items-center instance-info-line warn">
        <div class="mr-8 icon-container">
          <mat-icon svgIcon="error_outline" class="white-fg icon icon-md warn-solid-fg"></mat-icon>
        </div>
        <span class="termination-failed">
          {{'BLUEPRINT_SUMMARY.CONFIGURATION_FAILED' | transloco }}
        </span>
      </div>

      <div *ngIf="!serviceDefinitionUpdate && instance.status === DeployStatus.UPDATE_FAILED"
        class="flex flex-row justify-center items-center instance-info-line warn">
        <div class="mr-8 icon-container">
          <mat-icon svgIcon="error_outline" class="white-fg icon icon-md warn-solid-fg"></mat-icon>
        </div>
        <span class="termination-failed">
          {{'BLUEPRINT_SUMMARY.UPDATED_FAILED' | transloco }}
        </span>
      </div>
      <div *ngIf="!serviceDefinitionUpdate && instance.status === DeployStatus.UPDATING"
      class="flex flex-row justify-center items-center instance-info-line green p-0">
        <mat-icon svgIcon="settings" class="rotating icon-md-1 mr-6"></mat-icon>
        <span class="approved">
          {{'BLUEPRINT_SUMMARY.UPDATING' | transloco }}
        </span>
      </div>

      <div *ngIf="!serviceDefinitionUpdate && instance.status === DeployStatus.UPDATED
      && updateMessageRemainingTime < configStateMessageExpireTime"
      class="flex flex-row justify-center items-center instance-info-line green">
        <div class="mr-16 icon-container">
          <mat-icon svgIcon="check" class="icon icon-md bg-approved"></mat-icon>
        </div>
        <span class="approved">
          {{'BLUEPRINT_SUMMARY.UPDATED' | transloco }}
        </span>
      </div>

    <ng-container
      *ngIf="groupedWorkflowApprovals.get(blueprint.id + OperationType.CREATE_INSTANCE + instance.environment)"
      [ngTemplateOutlet]="approvalStatus"
      [ngTemplateOutletContext]="{workflowApproval: groupedWorkflowApprovals.get(blueprint.id + OperationType.CREATE_INSTANCE + instance.environment)}">
    </ng-container>

    <ng-container *ngIf="groupedWorkflowApprovals.get(instance.id + OperationType.UPDATE_INSTANCE)"
      [ngTemplateOutlet]="approvalStatus"
      [ngTemplateOutletContext]="{workflowApproval: groupedWorkflowApprovals.get(instance.id + OperationType.UPDATE_INSTANCE)}">
    </ng-container>

    <app-configuration-state
      *ngIf="instance.latestConfigurationState && instance.status !== DeployStatus.TERMINATING && instance.status !== DeployStatus.DEPLOYING && instance.status !== DeployStatus.FAILED"
      [configurationState]="instance.latestConfigurationState" [configurations]="configurations" [instance]="instance"
      [configStateMessageExpireTime]="configStateMessageExpireTime" [configStateVerify]="configStateVerify"
      [instanceConfigStatus]="instance?.latestConfigurationState?.status" (retry)="retryUpdate($event)"
      [configLastRecord]="configLastRecord"></app-configuration-state>
  </div>
</ng-template>

<ng-template #approvalStatus let-workflowApproval="workflowApproval">
  <div class="flex flex-row justify-center items-center workflow-approval-state"
    [ngClass]="workflowApproval.ticket.status === TicketStatus.PENDING ? 'pending' : 'approved' ">
    <mat-icon class="mr-14 mb-0 mat-subtitle-2"
      [svgIcon]="workflowApproval.ticket.status === TicketStatus.PENDING ? 'schedule' : 'done'"></mat-icon>
    <div class="mr-40">{{'BLUEPRINT_SUMMARY.WORKFLOW_APPROVAL.' + workflowApproval.operationType + '.' +
      workflowApproval.ticket.status | transloco}}</div>
    <button class="btn-link" *ngIf="workflowApproval.ticket.status !== TicketStatus.PENDING"
      (click)="abortWorkflowAproval(workflowApproval)" [disabled]="workflowApproval.aborting">
      {{'BLUEPRINT_SUMMARY.WORKFLOW_APPROVAL.ABORT' | transloco}}
    </button>
  </div>
</ng-template>

<ng-template #deployPTLButtons let-instance="instance" let-workflowApproval="workflowApproval">
  <!-- This button is commented to temporarily remove workflow approval for deploying PROD instance -->
  <!-- <button
    *ngIf="instance.environment === PathToLiveEnvironment.LIVE && workflowApproval?.ticket.status !== TicketStatus.APPROVED &&
      instance.status !== DeployStatus.DEPLOYING"
    class="rounded accent instance-summary-btn ml-12"
    [disabled]="(instance.previousInstance?.status | isNotIn: INSTANCE_DEPLOYED_STATES) || !permissionsMap[Permission.DEPLOY_PTL_INSTANCE] ||
      workflowApproval?.ticket.status === TicketStatus.PENDING || workflowApproval?.aborting"
    (click)="requestDeployApproval(instance)">
    {{'INSTANCE_SUMMARY.TABLE.REQUEST_DEPLOY' | transloco}}
  </button> -->
  <button *ngIf="instance.status === DeployStatus.FAILED
  && ((updatedPermissionsMap[PermissionKeys.INSTANCE_REDEPLOY_DATAZONE_PII] && instance?.dataZone === DataZone.SECURE)
  || (updatedPermissionsMap[PermissionKeys.INSTANCE_REDEPLOY_DATAZONE_LIVE] && instance?.dataZone === DataZone.LIVE)
  || (updatedPermissionsMap[PermissionKeys.INSTANCE_REDEPLOY_DATAZONE_NONPII] && instance?.dataZone === DataZone.DEVELOPMENT))" class="rounded ml-12 accent instance-summary-btn"
              (click)="onReDeploy(instance, $event)">
              {{'INSTANCE_SUMMARY.TABLE.RE_DEPLOY' | transloco}}
            </button>
  <button *ngIf="((updatedPermissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_NONPII] && instance?.dataZone === DataZone.DEVELOPMENT) || (updatedPermissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_PII] && instance?.dataZone === DataZone.SECURE)
  || (updatedPermissionsMap[PermissionKeys.INSTANCE_CREATE_DATAZONE_LIVE] && instance?.dataZone === DataZone.LIVE)) && (instance.status !== DeployStatus.DEPLOYING && instance.status !== DeployStatus.FAILED)" class="rounded ml-12" [ngClass]="(instance.previousInstance?.status | isNotIn: INSTANCE_DEPLOYED_STATES) ||
  workflowApproval?.aborting || instance.status === DeployStatus.DEPLOYING || !isDevInstanceDeployed? 'disable-accent': 'accent instance-summary-btn'" [disabled]="(instance.previousInstance?.status | isNotIn: INSTANCE_DEPLOYED_STATES) ||
      workflowApproval?.aborting || instance.status === DeployStatus.DEPLOYING"
    (click)="onDeploy(instance, workflowApproval, $event)">
    {{'INSTANCE_SUMMARY.TABLE.DEPLOY' | transloco}}
  </button>
</ng-template>

<ng-template #updatePTLButtons let-instance="instance" let-workflowApproval="workflowApproval">
</ng-template>

<ng-template #sandboxView>
  <div *ngIf="devInstance && (devInstance[0]?.status !== DeployStatus.FAILED && devInstance[0]?.status !== DeployStatus.TERMINATION_FAILED); else sandboxCreationFailed">
    <div class="flex flex-col max-width-lg white-bg">
      <div class="flex flex-col mb-20 mt-24">
        <ng-container *ngIf="!showStepsLoadingSection;else showDeploymentInProgress">
          <div class="flex-col" *ngIf="isEndpointAvailable;else endpointsNotAvailable">
            <div class="flex-row">
              <div class="mat-headline-4 fw-700 mb-12">{{'BLUEPRINT_SUMMARY.EXPLORE_CUSTOM_SANDBOX' | transloco}}</div>
            </div>
            <div class="mat-subtitle-2 fw-500 mb-30">
              Here are all the endpoints you need to fully explore your bespoke service.
            </div>
            <div class="flex flex-col endpoint-card pb-16 mt-20" *ngIf="accessTypeEndpoints?.length > 0">
              <div class="flex flex-row">
                <img class="w-36 h-34 mb-30 mr-16" src="/assets/images/View Sandbox.png">
                <div class="mat-headline-5 fw-700 mb-10">{{'BLUEPRINT_SUMMARY.VIEW_SANDBOX' | transloco}}</div>
              </div>
              <div class="flex-col endpoint-width">
                <div
                  *ngIf="devInstance && DeployStatus.DEPLOYED === devInstance[0]?.status && trialStatus.includes('expired'); else notExpired" class="wrapper">
                  <div class="flex flex-row bg-color">
                    <span class="endpoint-header-width fs-12 fw-700 p-8">{{'BLUEPRINT_SUMMARY.ENDPOINTS' | transloco | uppercase}}</span>
                    <span class="endpoint-description-width fs-12 fw-700 pt-8 pb-8">{{'BLUEPRINT_SUMMARY.DESCRIPTION' | transloco | uppercase}}</span>
                  </div>
                  <div class="flex flex-row justify-between border-bottom pt-12 pb-12 items-center" *ngFor="let accessTypeEndpoint of accessTypeEndpoints; let i = index;">
                    <div class="endpoint-header-width flex">
                      <a href="javascript:void(0);"
                      class="edit_hover_class endpoint-background-color disableExpired mr-24 no-underline p-6">
                        <mat-icon svgIcon="open_in_new" class="icon mr-6 h-18 w-18" (click)="openUrl(accessTypeEndpoint.url)" target="_blank"></mat-icon>
                        <span class="mat-body-1 fw-500 ml-4 mb-0 mr-12">{{accessTypeEndpoint?.name}}</span>
                        <mat-icon *ngIf="accessTypeEndpoint?.name" class="copyUrl pl-2 h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(accessTypeEndpoint?.url)"></mat-icon>
                      </a>
                    </div>
                    <span class="flex items-center endpoint-description-width fs-14 fw-500">{{accessTypeEndpoint?.description}}</span>
                  </div>
                </div>
                <ng-template #notExpired>
                  <div class="flex flex-row bg-color">
                    <span class="endpoint-header-width fs-12 fw-700 p-8">{{'BLUEPRINT_SUMMARY.ENDPOINTS' | transloco | uppercase}}</span>
                    <span class="endpoint-description-width fs-12 fw-700 pt-8 pb-8">{{'BLUEPRINT_SUMMARY.DESCRIPTION' | transloco | uppercase}}</span>
                  </div>
                  <div class="flex flex-row justify-between border-bottom pt-12 pb-12 items-center" *ngFor="let accessTypeEndpoint of accessTypeEndpoints; let i = index;">
                    <div class="endpoint-header-width flex">
                      <a href="javascript:void(0);" class="edit_hover_class endpoint-background-color mr-24 no-underline p-6"
                      >
                        <mat-icon svgIcon="open_in_new" class="icon mr-6 h-18 w-18" (click)="openUrl(accessTypeEndpoint.url)" target="_blank"></mat-icon>
                        <span class="mat-body-1 fw-500 ml-4 mb-0 mr-12">{{accessTypeEndpoint?.name}}</span>
                        <mat-icon *ngIf="accessTypeEndpoint?.name" class="copyUrl pl-2 h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(accessTypeEndpoint?.url)"></mat-icon>
                      </a>
                    </div>
                    <span class="flex items-center endpoint-description-width fs-14 fw-500">{{accessTypeEndpoint?.description ? accessTypeEndpoint?.description : '--'}}</span>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-col endpoint-card pb-16 mt-20" *ngIf="configTypeEndpoints?.length > 0">
              <div class="flex flex-row">
                <img class="w-36 h-34 mb-30 mr-16" src="/assets/images/Configure Workbench.png">
                <div class="mat-headline-5 fw-700 mb-10">{{'BLUEPRINT_SUMMARY.CONFIGURE_WORKBENCH' | transloco}}</div>
              </div>
              <div class="flex-col endpoint-width">
                <div
                  *ngIf="devInstance && DeployStatus.DEPLOYED === devInstance[0]?.status && trialStatus.includes('expired'); else notExpiredConfigTypeEndpoint" class="wrapper">
                  <div class="flex flex-row bg-color">
                    <span class="endpoint-header-width fs-12 fw-700 p-8">{{'BLUEPRINT_SUMMARY.ENDPOINTS' | transloco | uppercase}}</span>
                    <span class="endpoint-description-width fs-12 fw-700 pt-8 pb-8">{{'BLUEPRINT_SUMMARY.DESCRIPTION' | transloco | uppercase}}</span>
                  </div>
                  <div class="flex flex-row justify-between border-bottom pt-12 pb-12 items-center" *ngFor="let configTypeEndpoint of configTypeEndpoints; let i = index;">
                    <div class="endpoint-header-width flex">
                      <a href="javascript:void(0);"
                      class="edit_hover_class endpoint-background-color disableExpired mr-24 no-underline p-6">
                      <mat-icon svgIcon="open_in_new" class="icon mr-6 h-18 w-18" (click)="openUrl(configTypeEndpoint?.url)" target="_blank"></mat-icon>
                        <span class="mat-body-1 fw-500 fs-16 ml-4 mb-0 mr-12">{{configTypeEndpoint?.name}}</span>
                        <mat-icon *ngIf="configTypeEndpoint?.name" class="copyUrl pl-2 h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(configTypeEndpoint?.url)"></mat-icon>
                      </a>
                    </div>
                    <span class="flex items-center endpoint-description-width fs-14 fw-500">{{configTypeEndpoint?.description}}</span>
                  </div>
                </div>
                <ng-template #notExpiredConfigTypeEndpoint class="flex flex-wrap">
                  <div class="flex flex-row bg-color">
                    <span class="endpoint-header-width fs-12 fw-700 p-8">{{'BLUEPRINT_SUMMARY.ENDPOINTS' | transloco | uppercase}}</span>
                    <span class="endpoint-description-width fs-12 fw-700 pt-8 pb-8">{{'BLUEPRINT_SUMMARY.DESCRIPTION' | transloco | uppercase}}</span>
                  </div>
                  <div class="flex flex-row justify-between border-bottom pt-12 pb-12 items-center" *ngFor="let configTypeEndpoint of configTypeEndpoints; let i = index;">
                    <div class="endpoint-header-width flex">
                      <a href="javascript:void(0);" class="edit_hover_class endpoint-background-color mr-24 no-underline p-6">
                        <mat-icon svgIcon="open_in_new" class="icon mr-6 h-18 w-18" (click)="openUrl(configTypeEndpoint?.url)" target="_blank"></mat-icon>
                        <span class="mat-body-1 fw-500 ml-4 mb-0 mr-12">{{configTypeEndpoint?.name}}</span>
                        <mat-icon *ngIf="configTypeEndpoint?.name" class="copyUrl pl-2 h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(configTypeEndpoint?.url)"></mat-icon>
                      </a>
                    </div>
                    <span class="flex items-center endpoint-description-width fs-14 fw-500">{{configTypeEndpoint?.description ? configTypeEndpoint?.description : '--'}}</span>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-col endpoint-card pb-16 mt-20" *ngIf="exploreTypeEndpoints?.length > 0">
              <div class="flex flex-row">
                <img class="h-34 w-34 mb-30 mr-16" src="/assets/images/API Endpoints.png">
                <div class="mat-headline-5 fw-700 mb-24">{{'BLUEPRINT_SUMMARY.API_ENDPOINTS' | transloco}}</div>
              </div>
              <div class="flex-col endpoint-width">
                <div
                  *ngIf="devInstance && DeployStatus.DEPLOYED === devInstance[0]?.status && trialStatus.includes('expired'); else notExpiredExploreTypeEndpoint" class="wrapper">
                  <div class="flex flex-row bg-color">
                    <span class="endpoint-header-width fs-12 fw-700 p-8">{{'BLUEPRINT_SUMMARY.ENDPOINTS' | transloco | uppercase}}</span>
                    <span class="endpoint-description-width fs-12 fw-700 pt-8 pb-8">{{'BLUEPRINT_SUMMARY.DESCRIPTION' | transloco | uppercase}}</span>
                  </div>
                  <div class="flex flex-row justify-between border-bottom pt-12 pb-12 items-center" *ngFor="let exploreTypeEndpoint of exploreTypeEndpoints; let i = index;">
                    <div class="endpoint-header-width flex">
                      <a href="javascript:void(0);"
                      class="edit_hover_class endpoint-background-color disableExpired mr-24 no-underline p-6">
                      <mat-icon svgIcon="open_in_new" class="icon mr-6 h-18 w-18" (click)="openUrl(exploreTypeEndpoint?.url)" target="_blank"></mat-icon>
                      <span class="mat-body-1 fw-500 ml-4 mb-0 mr-12">{{exploreTypeEndpoint?.name}}</span>
                      <mat-icon *ngIf="exploreTypeEndpoint?.name" class="copyUrl pl-2 h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(exploreTypeEndpoint?.url)"></mat-icon>
                    </a>
                  </div>
                  <span class="flex items-center endpoint-description-width fs-14 fw-500">{{exploreTypeEndpoint?.description}}</span>
                </div>
                </div>
                <ng-template #notExpiredExploreTypeEndpoint class="flex flex-wrap">
                  <div class="flex flex-row bg-color">
                    <span class="endpoint-header-width fs-12 fw-700 p-8">{{'BLUEPRINT_SUMMARY.ENDPOINTS' | transloco | uppercase}}</span>
                    <span class="endpoint-description-width fs-12 fw-700 pt-8 pb-8">{{'BLUEPRINT_SUMMARY.DESCRIPTION' | transloco | uppercase}}</span>
                  </div>
                  <div class="flex flex-row justify-between border-bottom pt-12 pb-12 items-center" *ngFor="let exploreTypeEndpoint of exploreTypeEndpoints; let i = index;">
                    <div class="endpoint-header-width flex">
                      <a href="javascript:void(0);" class="edit_hover_class endpoint-background-color mr-24 no-underline p-6">
                        <mat-icon svgIcon="open_in_new" class="icon mr-6 h-18 w-18" (click)="openUrl(exploreTypeEndpoint?.url)" target="_blank"></mat-icon>
                        <span class="mat-body-1 fw-500 ml-4 mb-0 mr-12">{{exploreTypeEndpoint?.name}}</span>
                        <mat-icon *ngIf="exploreTypeEndpoint?.name" class="copyUrl pl-2 h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(exploreTypeEndpoint?.url)"></mat-icon>
                      </a>
                    </div>
                    <span class="flex items-center endpoint-description-width fs-14 fw-500">{{exploreTypeEndpoint?.description ? exploreTypeEndpoint?.description : '--'}}</span>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-col endpoint-card pb-16 mt-20" *ngIf="otherTypeEndpoints?.length > 0">
              <div class="flex flex-row">
                <img class="h-34 w-34 mb-30 mr-16" src="/assets/images/API Endpoints.png">
                <div class="mat-headline-5 fw-700 mb-24">{{'BLUEPRINT_SUMMARY.EXPLORE_ENDPOINTS' | transloco}}</div>
              </div>
              <div class="flex-col endpoint-width">
                <div
                  *ngIf="devInstance && DeployStatus.DEPLOYED === devInstance[0]?.status && trialStatus.includes('expired'); else notExpiredOtherTypeEndpoint" class="wrapper">
                  <div class="flex flex-row bg-color">
                    <span class="endpoint-header-width fs-12 fw-700 p-8">{{'BLUEPRINT_SUMMARY.ENDPOINTS' | transloco | uppercase}}</span>
                    <span class="endpoint-description-width fs-12 fw-700 pt-8 pb-8">{{'BLUEPRINT_SUMMARY.DESCRIPTION' | transloco | uppercase}}</span>
                  </div>
                  <div class="flex flex-row justify-between border-bottom pt-12 pb-12 items-center" *ngFor="let otherTypeEndpoint of otherTypeEndpoints; let i = index;">
                    <div class="endpoint-header-width flex">
                      <a href="javascript:void(0);"
                      class="edit_hover_class endpoint-background-color disableExpired mr-24 no-underline p-6">
                      <mat-icon svgIcon="open_in_new" class="icon mr-6 h-18 w-18" (click)="openUrl(otherTypeEndpoint?.url)" target="_blank"></mat-icon>
                    <span class="mat-body-1 fw-500 ml-4 mb-0 mr-12">{{otherTypeEndpoint?.name}}</span>
                    <mat-icon *ngIf="otherTypeEndpoint?.name" class="copyUrl pl-2 h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(otherTypeEndpoint?.url)"></mat-icon>
                  </a>
                </div>
                <span class="flex items-center endpoint-description-width fs-14 fw-500">{{otherTypeEndpoint?.description}}</span>
              </div>
                </div>
                <ng-template #notExpiredOtherTypeEndpoint class="flex flex-wrap">
                  <div class="flex flex-row bg-color">
                    <span class="endpoint-header-width fs-12 fw-700 p-8">{{'BLUEPRINT_SUMMARY.ENDPOINTS' | transloco | uppercase}}</span>
                    <span class="endpoint-description-width fs-12 fw-700 pt-8 pb-8">{{'BLUEPRINT_SUMMARY.DESCRIPTION' | transloco | uppercase}}</span>
                  </div>
                  <div class="flex flex-row justify-between border-bottom pt-12 pb-12 items-center" *ngFor="let otherTypeEndpoint of otherTypeEndpoints; let i = index;">
                    <div class="endpoint-header-width flex">
                      <a href="javascript:void(0);" class="edit_hover_class endpoint-background-color mr-24 no-underline p-6">
                        <mat-icon svgIcon="open_in_new" class="icon mr-6 h-18 w-18" (click)="openUrl(otherTypeEndpoint?.url)" target="_blank"></mat-icon>
                        <span class="mat-body-1 fw-500 ml-4 mb-0 mr-12">{{otherTypeEndpoint?.name}}</span>
                        <mat-icon *ngIf="otherTypeEndpoint?.name" class="copyUrl pl-2 h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(otherTypeEndpoint?.url)"></mat-icon>
                      </a>
                    </div>
                    <span class="flex items-center endpoint-description-width fs-14 fw-500">{{otherTypeEndpoint?.description ? otherTypeEndpoint?.description : '--'}}</span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #showDeploymentInProgress>
          <div class="flex flex-col justify-center items-center"
            *ngIf="isInit && [DeployStatus.DEPLOYING].includes(sandboxCreationStatus)">
            <div class="w-1/3">
              <div *ngIf="extendSandboxMessage" class="flex justify-center mat-headline-5 fw-700 mb-32">
                {{'BLUEPRINT_SUMMARY.EXTENDING_SANDBOX' | transloco}}</div>
              <div *ngIf="!extendSandboxMessage" class="flex justify-center mat-headline-5 fw-700 mb-32">
                {{'BLUEPRINT_SUMMARY.CREATING_SANDBOX' | transloco}}</div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              <div class="mat-caption fw-400 mt-6">Your sandbox is being provisioned. You will be notified
                once created</div>
            </div>

            <div class="md-stepper-horizontal orange">
              <div class="md-step active">
                <div class="flex justify-center items-center md-step-circle mat-body-1 fs-26">1</div>
                <div class="mat-subtitle-2 fw-500 mt-26">Your Sandbox is being developed at the moment. This might take
                  up
                  to 4 hours and we will notify you when it is ready for use.
                </div>
                <div class="md-step-bar-left"></div>
                <div class="md-step-bar-right"></div>
              </div>
              <div class="md-step active">
                <div class="flex justify-center items-center md-step-circle mat-body-1 fs-26">2</div>
                <div class="mat-subtitle-2 fw-500 mt-26">Meanwhile we suggest you to watch the recommended tutorial
                  videos
                  or learn more about SaaS banking in the University. </div>
                <div class="md-step-bar-left"></div>
                <div class="md-step-bar-right"></div>
              </div>
              <div class="md-step active">
                <div class="flex justify-center items-center md-step-circle mat-body-1 fs-26">3</div>
                <div class="mat-subtitle-2 fw-500 mt-26">Once the Sandbox is ready, you will find a link to this page on
                  your home screen. All the Sandbox endpoints will appear here.
                </div>
                <div class="md-step-bar-left"></div>
                <div class="md-step-bar-right"></div>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-container
          *ngIf="[DeployStatus.FAILED, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED].includes(devInstance?.status)">
          <div class="flex flex-col justify-center items-center">
            <img src="/assets/images/sandbox_big.png" />
            <div class="mat-subtitle-1 fw-700 fs-28">{{'INSTANCE_STATUS.' + devInstance?.status | transloco}}</div>
            <div class="mat-headline-6 fw-500 sandbox-description ta-center">
              {{'BLUEPRINT_SUMMARY.ERROR.SANDBOX_DESCRIPTION' | transloco}}
            </div>
            <div class="flex flex-row justify-center items-center mb-20 mt-36">
              <button class="white mr-20 report-letter-spacing" type="button" (click)="goBack()"> {{
                'BLUEPRINT_SUMMARY.ERROR.BACK' | transloco }} </button>
              <button class="error-report-bg-color accent report-letter-spacing" type="button"
                (click)="openContactForm()"> {{ 'BLUEPRINT_SUMMARY.ERROR.REPORT' | transloco }} </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <ng-template #endpointsNotAvailable>
      <div class="flex flex-col justify-center items-center mt-24">
        <mat-icon svgIcon="desktop_access_disabled" class="no-release-color icon-lg mr-12"></mat-icon>
        <div class="mat-subtitle-1 fw-700 mt-42 fs-28">{{'BLUEPRINT_SUMMARY.ERROR.ENDPOINTS_NOT_AVAILABLE' |
          transloco}}</div>
        <div class="mat-headline-6 fw-500 sandbox-description ta-center">
          {{'BLUEPRINT_SUMMARY.ERROR.ENDPOINTS_DESCRIPTION' | transloco}}
        </div>
        <div class="flex flex-row justify-center items-center mb-20 mt-36">
          <button class="white mr-20 report-letter-spacing" type="button" (click)="goBack()"> {{
            'BLUEPRINT_SUMMARY.ERROR.BACK' | transloco }} </button>
          <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="onSupportClick()">
            {{ 'BLUEPRINT_SUMMARY.ERROR.REPORT' | transloco }} </button>
        </div>
      </div>
    </ng-template>
  </div>
  <ng-template #sandboxCreationFailed>
    <div *ngIf="devInstance && devInstance[0]?.status === DeployStatus.FAILED; else sandboxTerminationFailed"
      class="flex flex-col justify-center items-center mt-20">
      <img src="/assets/images/sandbox_big.png" />
      <div class="mat-subtitle-1 fw-700 fs-28">{{'INSTANCE_STATUS.' + devInstance[0]?.status | transloco}}</div>
      <div class="mat-headline-6 fw-500 sandbox-description ta-center">
        {{'BLUEPRINT_SUMMARY.ERROR.SANDBOX_DESCRIPTION' | transloco}}
      </div>
      <div class="flex flex-row justify-center items-center mb-20 mt-36">
        <button class="white mr-20 report-letter-spacing" type="button" (click)="goBack()"> {{
          'BLUEPRINT_SUMMARY.ERROR.BACK' | transloco }} </button>
        <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{
          'BLUEPRINT_SUMMARY.ERROR.REPORT' | transloco }} </button>
      </div>
    </div>
  </ng-template>
  <ng-template #sandboxTerminationFailed>
    <div *ngIf="devInstance && devInstance[0]?.status === DeployStatus.TERMINATION_FAILED"
      class="flex flex-col justify-center items-center mt-20">
      <img src="/assets/images/Termination_Failed.svg" />
      <div class="mat-subtitle-1 fw-700 fs-28 termination-color">{{'INSTANCE_STATUS.sandbox_termination_failed' | transloco}}</div>
      <div class="mat-headline-6 fw-500 sandbox-description ta-center">
        {{'BLUEPRINT_SUMMARY.ERROR.SANDBOX_TERMINATION_DESCRIPTION' | transloco}}
      </div>
      <div class="flex flex-row justify-center items-center mb-20 mt-36">
        <button class="white mr-20 report-letter-spacing" type="button" (click)="goBack()"> {{
          'BLUEPRINT_SUMMARY.ERROR.BACK' | transloco }} </button>
        <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{
          'BLUEPRINT_SUMMARY.ERROR.REPORT' | transloco }} </button>
      </div>
    </div>
  </ng-template>
  <ng-container *ngIf="dataLoaded && capabilitiesGroups && devInstance[0]?.status !== DeployStatus.TERMINATION_FAILED">
    <div class="flex flex-col max-width-lg gray-40-bg">
      <div class="flex-col mb-160 mt-70">
        <div class="flex flex-row">
          <div class="mat-headline-4 fw-700 mb-12">{{'BLUEPRINT_SUMMARY.YOUR_SERVICE_CAPABILITIES' | transloco}}</div>
          <div class="flex flex-row ml-auto">
            <!-- <button class="flex flex-row basic-button mat-headline-6 fw-700 pr-0 mt-14 mb-0"
              (click)="createNewBtnEnable ? extendedService(blueprintLatestVersion?.capabilities?.length) : null"
              [ngClass]="[(!createNewBtnEnable) ? 'disabled-btn cursor-default' : 'cursor-pointer']" [disabled]="!permissionsMap[Permission.CREATE_SANDBOX] || blueprintLatestVersion?.capabilities?.length === 0
              || DeployStatus.DEPLOYED !== devInstance[0]?.status || trialStatus.includes('expired')"
              [matTooltip]="createNewBtnEnable ? '' : 'BLUEPRINT_SUMMARY.EXTEND_DISABLE' | transloco"
              matTooltipPosition="above"
              matTooltipClass="mat-tooltip tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16">
              <mat-icon svgIcon="edit" class="mr-12 icon-md-1"></mat-icon>
              {{ 'BLUEPRINT_SUMMARY.EXTEND.EXTEND_SANDBOX' | transloco }}
            </button> -->
            <button *ngIf="enterPriseSandbox" class="flex flex-row basic-button mat-headline-6 fw-700 pr-0 mt-14 mb-0 hidden" (click)="showViewDetails()">
              <mat-icon svgIcon="visibility" class="icon pt-2"></mat-icon>
              {{ 'BLUEPRINT_SUMMARY.VIEW_DETAILS' | transloco }}
            </button>
          </div>
          <button
            class="flex flex-row justify-center items-center basic-button p-16 estimate-btn w-250 h-48 ml-20 disabled hidden">
            <mat-icon svgIcon="file_download" class="icon-sm mr-10"></mat-icon>
            <span class="fw-700"> {{ "SOLUTION_SUMMARY.DOWNLOAD_ESTIMATE" | transloco }}</span>
          </button>
        </div>
        <div class="mat-subtitle-2 fw-500 mb-30">
          {{ 'BLUEPRINT_SUMMARY.YOUR_SERVICE_DESCRIPTION' | transloco }}
        </div>
        <div>
          <div class="mat-headline-5 fw-700 mb-24 mt-28">
            {{'INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES' | transloco}}
            ({{blueprintVersion?.capabilities?.length}})
          </div>
          <div class="flex flex-wrap ml--24 mr--12 pl-22 card-gap">
            <ng-container *ngFor="let capability of blueprintVersion.capabilities">
              <div class="w-25-percent pl-12 pr-12 mb-24 btn-bgcolor">
                <app-view-capability-card class="flex w-100-percent" [capability]="capability">
                </app-view-capability-card>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <span class="flex-auto"></span>
  </ng-container>
</ng-template>
